function RiskSimulation() {
  return null;
}

export default RiskSimulation;
